import { routes } from '@platform/core/lib/routes';

/** Частина старої адреси модуля `m/<ключ>/…` → нова: сторінка (p/), налаштування, проєктування, список (t/<тип>[/<подання>]) і запис (t/<тип>/r/<id>[/<вкладка>]). */
function legacyModulePath(key: string, [kind, a, b, c, d]: string[]): string {
  if (kind === 'p' && a) return routes.modulePage(key, a);
  if (kind === 'settings') return routes.moduleSettings(key, a);
  if (kind === 'design') return routes.moduleDesign(key, a);
  if (kind === 't' && a) return b === 'r' && c ? routes.record(key, a, c, d) : routes.list(key, a, b);
  return routes.module(key);
}

/**
 * Стара адреса `/w/<простір>/<rest>` (закладки, переспрямування зі старого домену) → адреса без простору (ADR-028): `m/<ключ>/…` — шлях
 * модуля за slug групи й модуля, `area/<група>` — `/<група>`, сторінки оболонки (inbox, search, work/…, admin/…, customize/…) — без
 * префікса; рядок запиту (`search`, з «?») зберігається. Простір вибирає маршрут переспрямування (LegacyRedirect).
 */
export function legacyPath(rest: string, search = ''): string {
  const [head, ...tail] = rest.split('/').filter(Boolean);
  const path = head === 'm' && tail[0] ? legacyModulePath(tail[0], tail.slice(1))
    : head === 'area' && tail[0] ? `/${tail[0]}`
      : `/${[head, ...tail].filter(Boolean).join('/')}`;
  return `${path}${search}`;
}
